import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import _adviserPortalHome from './_adviserPortalHome';
import { Container, Col, Row } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css'

// style={{height: totalFumDetails.productFum.length > 3 ? '112px' : '0px'}}
function TotalFumLeft(props) {
    const totalFumDetails = _adviserPortalHome._totalFumInDetail(props)
    const { t } = props;

    return (
        // <div>
        //     <Row>
        //         <Col className="adviser-data adviser-data-height" >
        //             <Link className="adviserLoginLink link" to="/adv/totalMembers">
        //                 <div className="adviserDataTotal"><CurrencyFormat value={Number(totalFumDetails.totalFum).toFixed(2)}
        //                     displayType={'text'}
        //                     thousandSeparator={true}
        //                     prefix={'$'} />
        //                 </div>{t('FUM:totalFum')}
        //             </Link>
        //         </Col>
        //     </Row>
        //     {
        //         totalFumDetails.productFum.map((fum, index) => 
        //             <Row key={index}>
        //                 <Col className="adviser-data adviser-data-height">
        //                         <Link className="adviserLoginDataLink link" to={`/adv/totalMembers/${fum.code}`}>
        //                             <div className="adviserDataSplit"><CurrencyFormat value={Number(fum.fum).toFixed(2)}
        //                                 displayType={'text'}
        //                                 thousandSeparator={true}
        //                                 prefix={'$'} />
        //                             </div>{fum.name}
        //                         </Link>
        //                 </Col>
        //             </Row>
        //         )
        //     }
        // </div>
        
        <tbody>
            <tr>
                <td><div><Link className="adviserLoginLink link" to="/adv/totalMembers">
                   <div className="adviserDataTotal"><CurrencyFormat value={Number(totalFumDetails.totalFum).toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'} />
                    </div>{t('FUM:totalFum')}
                </Link></div></td>
            </tr>
            {
                totalFumDetails.productFum.map((fum, index) => 
                    <tr key={index}>
                        <td>
                            <div>
                                <Link className="adviserLoginDataLink link" to={`/adv/totalMembers/${fum.code}`}>
                                    <div className="adviserDataSplit"><CurrencyFormat value={Number(fum.fum).toFixed(2)}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'} />
                                    </div>{fum.name}
                                </Link>
                            </div>
                        </td>
            </tr>
                    )
            }
        </tbody>
    )
}

export default withTranslation()(TotalFumLeft);